import React from 'react';
import { Snackbar, Alert, AlertProps } from '@mui/material';

export interface SnackbarFieldProps {
    open: boolean;
    message: string;
    severity?: AlertProps['severity'];
    autoHideDuration?: number;
    onClose: (event?: React.SyntheticEvent | Event, reason?: string) => void;
}

export function SnackbarField({
    open,
    message,
    severity = 'success',
    autoHideDuration = 4000,
    onClose,
}: SnackbarFieldProps) {
    return (
        <Snackbar
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={onClose}
        >
            <Alert severity={severity} variant="filled" sx={{ width: '100%' }}>
                {message}
            </Alert>
        </Snackbar>
    );
}
